export default "/fonts/vendor/katex/dist/KaTeX_Size4-Regular.ttf?4ad7c7e8bb8d10a34bb7c4bb567cef92";